import { Colors } from '@pinchenterprisesnpm/friday-ui'
import styled from 'styled-components'

export const SelectWrapper = styled.div`
  position: relative;
  margin-top: 12px;
`

export const FloatingLabel = styled.label<{
  hasValue: boolean
  isFocused: boolean
}>`
  position: absolute;
  left: 14px;
  top: ${(props) => (props.hasValue || props.isFocused ? '17px' : '20px')};
  transition: all 0.2s ease;
  font-size: 14px;
  color: #868686;
  padding: 0 4px;
  pointer-events: none;
  z-index: 2;
  line-height: 1;
  font-weight: 500;
`

export const customSelectStyles = (ptValueContainer?: string) => ({
  control: (base: any, state: any) => ({
    ...base,
    minHeight: '42px',
    paddingTop: '14px',
    paddingLeft: '12px',
    paddingRight: '12px',
    borderColor: state.isFocused ? Colors.primary : base.borderColor,
    boxShadow: state.isFocused ? `0 0 0 1px ${Colors.primary}` : base.boxShadow,
    '&:hover': {
      borderColor: state.isFocused ? Colors.primary : base.borderColor,
    },
    cursor: state.isDisabled ? 'not-allowed' : 'pointer',
  }),
  valueContainer: (base: any) => ({
    ...base,
    paddingTop: ptValueContainer ?? '8px',
    paddingBottom: '4px',
    paddingLeft: '4px',
  }),
  placeholder: (base: any) => ({
    ...base,
    marginLeft: 0,
    marginRight: 0,
  }),
  singleValue: (base: any) => ({
    ...base,
    marginLeft: 0,
    marginRight: 0,
  }),
  input: (base: any) => ({
    ...base,
    marginLeft: 0,
    paddingLeft: 0,
  }),
})
